import {Dialog, DialogTitle, Grid} from '@material-ui/core'
import {Alert} from '@material-ui/lab'
import {useEffect} from 'react'
import {useState} from 'react'
import {passwordRulesString, verifyPasswordEntryForm} from 'src/validations/password'
import TextInput from '../TextInput'
import Subtitle2 from '../Typography/Subtitle2'
import {ButtonCancel, ButtonSave, ButtonsBox, FormContainer} from './styled'

export type PasswordDialogProps = {
  open: boolean
  title: string
  onClose: (newPassword: string | undefined) => void
}

const PasswordDialog: React.FC<PasswordDialogProps> = ({
  open,
  title,
  onClose,
}: PasswordDialogProps) => {
  const [passwordErrorString, setPasswordErrorString] = useState<string>()
  const [passwordField01, setPasswordField01] = useState<string>()
  const [passwordField02, setPasswordField02] = useState<string>()

  const onSaveClick = () => {
    // User clicked save, make sure the password is OK.
    const validate = verifyPasswordEntryForm(passwordField01, passwordField02)

    if (!passwordField01 || !passwordField02) {
      setPasswordErrorString('Please enter a password')
    } else if (validate === true) {
      // We're clear!
      onClose(passwordField01)
    } else {
      setPasswordErrorString(validate as string)
    }
  }

  ///
  /// Any time the dialog box opens we need to clear any lingering password errors
  ///
  useEffect(() => {
    if (open === true) {
      setPasswordErrorString(undefined)
    }
  }, [open])

  return (
    <Dialog open={open} maxWidth="lg" fullWidth={true}>
      <DialogTitle>{title}</DialogTitle>
      <FormContainer>
        <Grid container spacing={5} xs={12}>
          <Grid item xs={6}>
            <TextInput
              onChangeText={setPasswordField01}
              onSubmitEditing={onSaveClick}
              type="password"
              fullWidth={true}
              id="password"
              label="Password"
            />
          </Grid>

          <Grid item xs={6}>
            <TextInput
              onChangeText={setPasswordField02}
              onSubmitEditing={onSaveClick}
              type="password"
              fullWidth={true}
              id="password_verify"
              label="Password Verify"
            />
          </Grid>

          <Grid item xs={12}>
            {!passwordErrorString && <Subtitle2>{passwordRulesString()}</Subtitle2>}
            {passwordErrorString && <Alert severity="error">{passwordErrorString}</Alert>}
          </Grid>
        </Grid>
        <ButtonsBox display="flex" flexDirection="row-reverse">
          <ButtonSave
            onClick={() => {
              onSaveClick()
            }}>
            Save
          </ButtonSave>
          <ButtonCancel
            onClick={() => {
              onClose(undefined)
            }}
            color="secondary">
            Cancel
          </ButtonCancel>
        </ButtonsBox>
      </FormContainer>
    </Dialog>
  )
}

export default PasswordDialog
